import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../api";

// ACTIONS --------------------------------------------------------------------

/**
 * @desc Add to wishlist.
 */
export const addToWishlist = createAsyncThunk(
  "wishlist/add",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { pending } = getState();
      if (!pending) {
        const { pid, wid } = data;
        const response = await API.Wishlist.Add({
          params: {
            psku: pid,
            id: wid,
          },
        });
        return response;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @desc Remove from wishlist.
 */
export const removeFromWishlist = createAsyncThunk(
  "wishlist/remove",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { pending } = getState();
      if (!pending) {
        const { pid, wid } = data;
        const response = await API.Wishlist.Remove({
          params: {
            psku: pid,
            id: wid,
          },
        });
        return response;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// SLICE ----------------------------------------------------------------------

/**
 * @desc Wishlist Slice.
 */
export const wishlistSlice = createSlice({
  name: "wishlist",
  initialState: {
    cname: "",
    pskus: [],
    show: false,
  },
  reducers: {
    setWishlistStore: (state, action) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        state[key] = value;
      });
    },
    setShowWishlist: (state, action) => {
      state.show = !!action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addToWishlist.pending, (state) => {
        state.pending = true;
      })
      .addCase(addToWishlist.fulfilled, (state, action) => {
        Object.entries(action.payload).forEach(([key, value]) => {
          state[key] = value;
        });
        state.pending = false;
      })
      .addCase(addToWishlist.rejected, (state) => {
        state.pending = false;
      })
      .addCase(removeFromWishlist.pending, (state) => {
        state.pending = true;
      })
      .addCase(removeFromWishlist.fulfilled, (state, action) => {
        Object.entries(action.payload).forEach(([key, value]) => {
          state[key] = value;
        });
        state.pending = false;
      })
      .addCase(removeFromWishlist.rejected, (state) => {
        state.pending = false;
      });
  },
});

// ACTIONS --------------------------------------------------------------------

export const { setWishlistStore, setShowWishlist } = wishlistSlice.actions;

// SELECTORS ------------------------------------------------------------------

export const getWishlistSelector = (state) => state.wishlist;

export const getWishlistProductsSelector = (state) => state.wishlist.pskus;

export const getWishlistShowSelector = (state) => state.wishlist.show;

// REDUCER --------------------------------------------------------------------

export default wishlistSlice.reducer;
